import { loader } from 'graphql.macro'

export default function dispatcherPayment ({ dataLoaders, queryKey }) {
  const [, variables] = queryKey
  const schema = loader('./dispatcherPayment.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(schema, {
    paymentId: variables.paymentId
  })
}
